import { ID } from '../../types/typeDef';

export const getValidShop = (nbVentes: number, isProf: boolean) => {
  return nbVentes >= 1 || isProf;
};

export const getShopUrl = (shopCode: string, classeID: ID) => {
  const baseUrl = window.location.host;
  return baseUrl + '/e-boutique/' + shopCode + '/' + classeID;
};
